import { useEffect, useState } from "react";
import { PicoAppDto } from "jadro-pico/apps/PicoAppDto.ts";
import { apiFetch } from "../../../Api/apiFetch";

const EMPTY_APPS: PicoAppDto[] = [];

export function useLauncherApps(enabled: boolean = true): PicoAppDto[] {
  const [apps, setApps] = useState<PicoAppDto[]>([]);

  useEffect(() => {
    if (!enabled) return;
    const controller = new AbortController();
    apiFetch<PicoAppDto[]>(`${import.meta.env.VITE_PICO_API_URL}/apps`, {
      allowAnonymous: true,
      signal: controller.signal,
    })
      .then((catalog) => setApps((catalog ?? []).filter((app) => app.showInLauncher)))
      .catch(() => undefined);
    return () => controller.abort();
  }, [enabled]);

  return enabled ? apps : EMPTY_APPS;
}
